// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/pattern-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* @tokens Colors
* @presenter Color
*/
.brand-grey-400 {
  color: #bdbdbd;
}
.brand-grey-500 {
  color: #9e9e9e;
}
.brand-grey-600 {
  color: #757575;
}
.brand-grey-700 {
  color: #616161;
}
.status-error {
  color: #b00020;
}
.status-yellow {
  color: #aa8a22;
}
.status-success {
  color: #1eb980;
}
.status-success-grey-700 {
  color: #616161;
}
.text-white {
  color: #fff;
}
.line {
  border: 1px solid #f4f2f7;
  margin-top: 2%;
  width: 100%;
  margin-bottom: 2%;
}
@media (max-width: 767px) {
.line {
    display: none;
}
}
@media (max-width: 767px) {
.mobile-line {
    border: 1px solid #f4f2f7;
    margin-right: 10%;
    width: 90%;
    margin-bottom: 2%;
}
}
.modal {
  left: 1%;
  position: relative;
  height: 100%;
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 30px;
}
@media (max-width: 767px) {
.modal {
    display: block;
    height: 95%;
}
}
.modal-container {
  height: 7%;
  width: 94%;
  margin: 3%;
}
@media (max-width: 767px) {
.modal-container {
    height: 12%;
}
}
.modal-header {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
.modal-header {
    height: 85%;
}
}
.modal-header-container {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f4f2f7;
  margin: 0;
}
@media (max-width: 767px) {
.modal-header-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
}
}
.modal-header-container-subheading {
  display: none;
}
@media (max-width: 767px) {
.modal-header-container-subheading {
    display: inline-block;
    width: 100%;
    height: 25%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 80%;
    left: 0;
}
.modal-header-container-subheading > .modal-header-text {
    font-size: 13px;
    white-space: nowrap;
}
}
@media (max-width: 767px) {
.modal-header-container-text {
    width: 100%;
    height: 95%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 0;
    left: 0;
}
}
.modal-header-arrow {
  width: 10%;
  height: 100%;
  justify-content: center;
  cursor: pointer;
}
@media (max-width: 767px) {
.modal-header-arrow-image {
    width: 23px;
}
}
@media (max-width: 767px) {
.modal-header-arrow {
    z-index: 99999;
    padding-top: 0;
    width: 100%;
    height: 80%;
}
}
.modal-header-logo {
  display: none;
  width: 90%;
  height: 100%;
}
@media (max-width: 767px) {
.modal-header-logo {
    display: flex;
    width: 100%;
    height: 45%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    background-color: transparent;
    right: 0;
    justify-content: center;
    align-items: center;
}
}
@media (max-width: 767px) {
.modal-header-logo > img {
    width: 50%;
    height: 80%;
}
}
@media (max-width: 767px) {
.modal-header-progress {
    height: 95%;
    width: 100%;
    margin-top: 0;
    z-index: 0;
    position: absolute;
    background-color: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    align-content: flex-end;
    flex-wrap: wrap;
}
}
@media (max-width: 767px) and (max-width: 767px) {
.modal-header-progress > img {
    width: 15%;
    height: 20%;
}
}
.modal-header-text {
  width: 100%;
  height: 50%;
  color: #9e9e9e;
  margin-left: 2%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
}
@media (max-width: 767px) {
.modal-header-text {
    margin-left: 0;
    display: contents;
    flex-direction: column;
    flex-wrap: nowrap;
    z-index: 0;
    background-color: transparent;
}
}
.modal-body {
  position: relative;
  height: 85%;
  width: 95%;
  text-align: center;
  font-family: Jost, sans-serif;
}
@media (max-width: 767px) {
.modal-body {
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 29px;
    margin-left: 2.5%;
}
}
.modal_text-input-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}
.modal_text-input-container_title {
  width: 448px;
  height: 20px;
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  padding-bottom: 10px;
}
.modal_text-input-container_title > span {
  color: #757575;
  font-weight: 400;
}
.modal_text-input-container_single {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_single {
    width: 95%;
}
}
.modal_text-input-container_double-column {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  margin-top: 0;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_double-column {
    flex-direction: column;
    align-items: flex-start;
}
}
.modal_button-container {
  margin: 2% 0;
  height: 5%;
  display: flex;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
@media (max-width: 767px) {
.modal_button-container {
    justify-content: center;
}
}
@media (max-width: 767px) {
.modal_button-container .yc--button {
    width: 100%;
}
}
@media (max-width: 767px) {
.logo {
    width: 100%;
    height: 100%;
}
}
body {
  margin: 0px;
  height: 100%;
}
html {
  padding: 0px;
  margin: 0px;
  font-family: "Jost", sans-serif;
  line-height: 1.5;
}
.view_component {
  margin: 0px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #2F1C50;
  padding-top: 72px;
  background-size: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media screen and (max-height: 800px) {
.view_component {
    padding-top: 15px;
}
}
.view_component-logo {
  padding-bottom: 50px;
}
@media screen and (max-height: 800px) {
.view_component-logo {
    padding-bottom: 5px;
}
}
@media (max-width: 768px) {
.view_component {
    background-color: #fff;
    background-image: none;
    padding-top: 0;
    min-height: 800px;
    overflow-y: scroll;
}
.view_component-logo {
    height: 30px;
    display: none;
}
}
.wallet-address-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.wallet-address-header {
  width: 94%;
  margin: 3%;
  height: 50px;
  min-height: 50px;
}
@media (max-width: 767px) {
.wallet-address-header {
    height: 70px;
    min-height: 70px;
}
}
.wallet-address-body {
  width: 94%;
  height: 69%;
  margin: 2% 3%;
  margin-bottom: 0.5%;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
@media (max-width: 767px) {
.wallet-address-body {
    height: 70%;
}
}
.wallet-address-body-error-container {
  width: 93%;
  position: relative;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.wallet-address-body-error-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #b00020;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}
.wallet-address-body-prompt {
  min-height: 40px;
  width: 94%;
  margin: 0% 3%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 22px;
  font-family: Jost, "sans-serif";
  color: #000000;
  margin-bottom: 1%;
}
@media (max-width: 767px) {
.wallet-address-body-prompt {
    font-size: 18px;
    margin: 0px;
    width: 100%;
}
}
.wallet-address-body-prompt-subtitle {
  min-height: 30px;
  width: 94%;
  margin: 1% 3%;
  font-family: Jost, "sans-serif";
  font-weight: 400;
  font-size: 14px;
  color: #616161;
}
@media (max-width: 767px) {
.wallet-address-body-prompt-subtitle {
    width: 100%;
    margin: 0px;
}
}
.wallet-address-body-prompt-subtitle > span {
  font-weight: 700;
  color: #000000;
}
.wallet-address-body-error {
  font-weight: 400;
  font-size: 12px;
  color: #b00020;
  font-family: Jost, "sans-serif";
  height: 5%;
  margin-top: 2%;
  width: 95%;
}
.wallet-address-body-tag-container {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  height: 100%;
  margin-top: 5px;
  margin-bottom: 15px;
}
.wallet-address-body-tag-text {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 95%;
  margin: 0% 3%;
  margin-bottom: 10px;
  font-family: Jost, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
@media (max-width: 767px) {
.wallet-address-body-tag-text {
    width: 100%;
    margin: 3% 0%;
    margin-bottom: 10px;
}
}
.wallet-address-body-tag-text img {
  width: 9%;
  height: auto;
  margin-left: 4px;
}
.wallet-address-body-tag-box {
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  width: 95%;
  margin: 0% 3%;
  padding: 12px 16px 12px 16px;
  border-radius: 16px 16px 16px 16px;
  background: #fff5d6;
}
@media (max-width: 767px) {
.wallet-address-body-tag-box {
    width: 100%;
    margin: 3% 0%;
}
}
.wallet-address-body-form-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  margin-top: 2%;
  padding-bottom: 10px;
}
.wallet-address-body-input {
  width: 95%;
  margin: 0% 3%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding-bottom: 10px;
}
@media (max-width: 767px) {
.wallet-address-body-input {
    width: 100%;
    margin: 3% 0%;
}
}
.wallet-address-body-input .yc--input {
  width: 100%;
}
.wallet-address-body-input .yc--input__label {
  display: none !important;
}
.wallet-address-body-input .yc--input__input-container {
  height: 100%;
}
@media (max-width: 767px) {
.wallet-address-body-input .yc--input__hide-show {
    top: -60%;
    left: 90%;
    position: relative;
}
}
.wallet-address-body-input .yc--input__input {
  padding: 10px 5px;
  height: 100%;
  font-size: 16px;
  font-weight: 400;
  font-family: Jost, "sans-serif";
  padding: 16px;
  border-radius: 16px;
  padding-right: 47px;
  text-overflow: ellipsis;
}
.wallet-address-body-input .yc--input__input:focus {
  padding: 16px;
}
.wallet-address-body-purpose {
  width: 95%;
  margin: 0% 3%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding-bottom: 4px;
}
@media (max-width: 767px) {
.wallet-address-body-purpose {
    width: 100%;
    margin: 3% 0%;
}
}
.wallet-address-body-purpose .yc--input {
  width: 100%;
}
.wallet-address-body-purpose .yc--input__label {
  display: none !important;
}
.wallet-address-body-purpose .yc--input__input-container {
  height: 100%;
}
@media (max-width: 767px) {
.wallet-address-body-purpose .yc--input__hide-show {
    top: -60%;
    left: 90%;
    position: relative;
}
}
.wallet-address-body-purpose .yc--input__input {
  padding: 10px 5px;
  height: 100%;
  font-size: 16px;
  font-weight: 400;
  font-family: Jost, "sans-serif";
  padding: 16px;
  border-radius: 16px;
  padding-right: 47px;
  text-overflow: ellipsis;
}
.wallet-address-body-purpose .yc--input__input:focus {
  padding: 16px;
}
.wallet-address-body-tos {
  height: 5%;
  width: 90%;
  margin: 3%;
  font-size: 14px;
  color: #9e9e9e;
}
.wallet-address-body-tos > span {
  color: #492b7c;
}
.wallet-address-footer {
  width: 96%;
  margin: 2% 2% 1% 2%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 767px) {
.wallet-address-footer {
    margin: 2%;
}
}
.wallet-address-footer .yc--button {
  border-radius: 72px;
  font-family: Jost, "sans-serif";
  font-size: 16px;
  border: none !important;
}
.mobile {
  display: none;
}
@media (max-width: 767px) {
.mobile {
    display: block;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
